/**
 * Extends AbstractDownloadDialog to display a CSV format containing configured fields from the
 * selected sites.
 */

import AbstractDownloadDialog from './abstract-download-dialog';
import * as DatasetHelper from '../../../utils/dataset-helper';
export default class DownloadCsvDialogComponent extends AbstractDownloadDialog {

  buildHtml(options) {
    let _activeDataset = options.datasetsModel.getActiveDataset();
    let _referenceSites = options.referenceSitesModel.getData();
    let _referenceSitesHash = options.referenceSitesHashModel.getData();
    let _selectedSites = options.selectedSitesModel.getData();

    // Start building the list of sites to output. First step is to identify if the site has a
    // non-blank/non-empty 'Project' property. If so, we mark this site are 'Removed' unless it has
    // been selected (which will check for afterward).
    let sitesList = _referenceSites
      .filter(site => {
        return site.data.Project && site.data.Project.length > 0 &&
          site.data.Project.toLowerCase() !== 'new';
      })
      .map(site => {
        return {
          id: site.id,
          status: 'removed'
        };
      });

    // Add all selected sites to this list. If the site already exists in the list, change it's
    // status to 'Existing', otherwise set it's status as 'New'.
    Object.keys(_selectedSites).forEach(selectedSiteId => {

      // Determine if the site is already in the sitesList.
      const existingSite = sitesList.find(_existingSite => {
        return _existingSite.id === selectedSiteId;
      });

      // If the site already exists, change status to 'Existing', otherwise add with status 'New'.
      if (existingSite) {
        existingSite.status = 'existing';
      } else {
        sitesList.push({
          id: selectedSiteId,
          status: 'new'
        });
      }
    });

    // Build CSV.
    let html = '';
    html += '"id","lon","lat","name"';
    options.config.includedFields.forEach(fieldName => {
      html += `,"${fieldName}"`;
    });
    html += ',"status"\n';

    // Loop through each site to output.
    sitesList.forEach(site => {

      // Find the site in the reference data.
      const referenceSite = _referenceSitesHash[site.id];
      if (referenceSite) {

        // Always include siteId and lat/lon.
        html += `${referenceSite.id},${referenceSite.lon},${referenceSite.lat},"${referenceSite.name}"`;

        // Include all configured fields.
        options.config.includedFields.forEach(fieldId => {
          const field = DatasetHelper.findField(_activeDataset, fieldId);
          let fieldValue = (referenceSite.data[field.fieldName] ?
            referenceSite.data[field.fieldName] : '');
          if (field.type !== 'numerical') {
            fieldValue = `"${fieldValue}"`;
          }
          html += `,${fieldValue}`;
        });

        // Include the status.
        html += `,"${site.status}"\n`;
      }

    });
    return html;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/download-csv-dialog.js